module.exports = __webpack_public_path__ + "img/EducationalGroupTransfers.8e0c7058.svg";